import React, { lazy } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CountdownBadge } from './CountdownBadge';
export function HeroSection() {
  return <section className="py-16 bg-gradient-to-b from-green-50 to-white" data-id="element-113">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="text-center mb-10" data-id="element-115">
          <h1 className="text-4xl md:text-5xl font-extrabold text-green-800 mb-4" data-id="element-116">
            <span className="inline-block" data-id="element-117">
              🌿 KIT DE EMERGENCIA ANTI-ESTRÉS 🌿
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-green-700 mb-8" data-id="element-118">
            Tu botiquín de calma instantáneo para cuando la ansiedad no espera.
          </p>
          <div className="max-w-3xl mx-auto" data-id="element-119">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6" data-id="element-120">
              ¿Y si el estrés no fuera el problema?
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-121">
              ¿Y si el verdadero enemigo… fuera no tener un botón de pausa?
            </p>
            <p className="text-lg text-gray-700 mb-8" data-id="element-122">
              Vivimos en alerta constante. La mente no para. El cuerpo se tensa.
              Y la calma… parece siempre llegar tarde.
            </p>
            <p className="text-lg text-gray-700 italic mb-10" data-id="element-123">
              Pero algo dentro de ti… ya sabe que necesita un cambio. Uno que no
              dependa de pastillas, de distracciones o de "aguantar un poco
              más".
            </p>
          </div>
          <div className="mt-8 flex justify-center" data-id="element-124">
            <a href="https://clickylee.com/products/kit-de-emergencias-anti-stress-5-bonos-gratis?variant=46954999415019" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" data-id="element-125">
              Descargar Ahora
              <ArrowRightIcon className="ml-2 -mr-1 h-4 w-4" data-id="element-126" />
            </a>
          </div>
          <div className="mt-6 flex justify-center space-x-4" data-id="element-127">
            <CountdownBadge data-id="element-128" />
            <div className="bg-amber-50 text-amber-800 px-3 py-1 rounded-full text-xs font-medium inline-flex items-center" data-id="element-129">
              <span data-id="element-130">Solo por tiempo limitado</span>
              <span className="font-bold ml-1" data-id="element-131">$19.997 ARS</span>
            </div>
          </div>
        </div>
        <div className="mt-10 flex justify-center" data-id="element-132">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jenRCUvUKSzkShErgrJLR5/ChatGPT_Image_11_oct_2025%2C_18_47_25.png" alt="Kit de Emergencia Anti-Estrés" className="max-w-full h-auto rounded-lg shadow-lg max-h-96 object-contain" loading="lazy" data-id="element-133" />
        </div>
      </div>
    </section>;
}